export const buttonTemplate = `
<!--[if mso | IE]>
<table align="center"
       border="0"
       cellpadding="0"
       cellspacing="0"
       class=""
       role="presentation"
       style="width:600px;"
       width="600"
>
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
<![endif]-->
<div style="margin:0px auto;max-width:600px;">
  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
    <tbody>
      <tr>
        <td style="direction:ltr;font-size:0px;padding:0 0 40px 0;text-align:center;">
          <!--[if mso | IE]>
          <table role="presentation" border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td align="center" class="" style="">
          <![endif]-->
          <table border="0"
                 cellpadding="0"
                 cellspacing="0"
                 role="presentation"
                 style="border-collapse:separate;line-height:100%;"
          >
            <tbody>
              <tr>
                <td align="center"
                    bgcolor="#4663AB"
                    role="presentation"
                    style="border:none;border-radius:10px;cursor:auto;height:40px;mso-padding-alt:10px 50px;background:#4663AB;"
                    valign="middle"
                >
                  <a href="{{ link_0_url }}"
                     style="display:inline-block;background:#4663AB;color:white;font-family:Verdana, Geneva, Helvetica, Arial, sans-serif;font-size:16px;font-weight:600;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 50px;mso-padding-alt:0px;border-radius:10px;"
                     target="_blank"
                  >
                    {{ link_0_text }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!--[if mso | IE]></td></tr></table><![endif]-->
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->

`;